module.exports = __webpack_public_path__ + "static/media/2002_maleRate_femaleRate.c4dde5f8.png";